import React from 'react';

import { AppSidebarToggler } from '@coreui/react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Nav } from 'reactstrap';

import SearchBar from '../../components/SearchBar/SearchBar';
import { prefix as academyPrefix } from '../../routes/academy';
import authService from '../../services/Auth';
import DefaultHeaderDropdown from './DefaultHeaderDropdown';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

function DefaultHeader(props) {
  const location = useLocation();

  const disableSearch = location.pathname.startsWith(academyPrefix);

  return (
    <>
      <AppSidebarToggler className='d-lg-none' display='md' mobile />
      {authService.isAuthenticated() && (
        <>
          <Nav className='ml-md-4' navbar>
            {disableSearch ? null : <SearchBar />}
          </Nav>
          <Nav className='ml-auto' navbar>
            <DefaultHeaderDropdown accnt {...props} />
          </Nav>
        </>
      )}
    </>
  );
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;
